import React, { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { IoCheckmarkCircle, IoCloseCircle, IoTimeOutline } from "react-icons/io5";
import "../../styles/thankyou.css";

// Where CCAvenue's result lands the donor. The backend has already recorded
// the payment before redirecting here; the query string only says what to show.
const TYPES = {
    donation: { label: "donation", retry: "/quick-donation" },
    "food-donation": { label: "Food for Life donation", retry: "/donate/food-for-life" },
    "festival-seva": { label: "seva", retry: "/donate/other-seva" },
    "puja-booking": { label: "puja booking", retry: "/booking/offer-puja" },
    "life-membership": { label: "Life Membership", retry: "/lifetime-membership" },
};

const VIEWS = {
    success: {
        Icon: IoCheckmarkCircle,
        color: "var(--color-green)",
        title: "Thank You! Hare Krishna",
        message: (label) =>
            label === "puja booking"
                ? "Your payment was successful and your puja has been booked."
                : `Your payment was successful and your ${label} has been received. The receipt will be sent to you on WhatsApp and email.`,
    },
    failed: {
        Icon: IoCloseCircle,
        color: "#c0392b",
        title: "Payment Failed",
        message: (label) =>
            `Your payment for the ${label} did not go through. If any amount was deducted, your bank will refund it automatically in 5-7 working days.`,
    },
    cancelled: {
        Icon: IoCloseCircle,
        color: "#c0392b",
        title: "Payment Cancelled",
        message: (label) => `You cancelled the payment, so your ${label} was not completed. Nothing has been charged.`,
    },
    pending: {
        Icon: IoTimeOutline,
        color: "#b7791f",
        title: "Payment Being Confirmed",
        message: (label) =>
            `We received your payment response for the ${label} but could not confirm it yet. Please do not pay again — contact us with the Order ID below.`,
    },
};

export default function PaymentStatus() {
    const [params] = useSearchParams();
    const status = VIEWS[params.get("status")] ? params.get("status") : "failed";
    const type = TYPES[params.get("type")] || { label: "payment", retry: "/quick-donation" };
    const view = VIEWS[status];
    const order = params.get("order");
    const ref = params.get("ref");
    const amount = Number(params.get("amount"));

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const details = [
        status === "success" && amount > 0 && { label: "Amount", value: `₹${amount.toLocaleString("en-IN")}` },
        order && { label: "Order ID", value: order },
        ref && { label: "Payment Reference", value: ref },
    ].filter(Boolean);

    const { Icon } = view;
    return (
        <section className="ikty-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-9 col-lg-7">
                        <div className="ikty-card text-center">
                            <div className="ikty-icon-wrap">
                                <Icon className="ikty-icon" style={{ color: view.color }} />
                            </div>

                            <h1 className="ikty-title">{view.title}</h1>
                            <p className="ikty-message">{view.message(type.label)}</p>

                            {details.length > 0 && (
                                <div className="ikty-details">
                                    {details.map((d) => (
                                        <div className="ikty-detail-row" key={d.label}>
                                            <span className="ikty-detail-label">{d.label}</span>
                                            <span className="ikty-detail-value">{d.value}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className="ikty-actions d-flex flex-wrap justify-content-center gap-3">
                                {(status === "failed" || status === "cancelled") && (
                                    <Link to={type.retry} className="ikty-btn ikty-btn-outline">
                                        Try Again
                                    </Link>
                                )}
                                <Link to="/" className="ikty-btn ikty-btn-solid">
                                    Back to Home
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
